<template>
  <div>
    <div class="d-flex align-center text-center mb-8">
      <v-btn 
        large 
        dark
        color="#313a46"
        class="mr-1 elevation-0"
        icon 
        @click="pageReturn()"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <p class="title-page ma-0">Logins</p>
    </div>
    <TableLogins 
      @description="description = $event"
    />
  </div>
</template>

<script>
import TableLogins from "../components/TableLogins.vue";

export default {
  name: "ServicosPrestados",

  components: {
    TableLogins,
  },

  data() {
    return {
      description: "",
    };
  },

  methods: {
    pageReturn() {
      this.$router.go(-1);
    },
  },
};
</script>
